



















































































































































































import { defineComponent, reactive, toRefs, onMounted, ref } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http"
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import AlertArea from "../../components/AlertArea.vue"
import CustomConfirmModal from "../../components/CustomConfirmModal.vue"
import { BaseSheet } from "../../modules/teacher/ApprovalBaseSheetEdit"

export interface Data {
  base_sheet_id: string
  baseSheet: BaseSheet | null
  isSheetTypeEditable: boolean
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    'date-time-picker' : VueCtkDateTimePicker,
  },
  setup(props, context){

    const customConfirmModalRef = ref<InstanceType<typeof CustomConfirmModal>>();

    const state = reactive<Data>({
      base_sheet_id: null,
      baseSheet: null,
      isSheetTypeEditable: false,
      errors: [],
    });

    const updateClick = async () => {
      state.errors = [];

      if(!state.baseSheet.sheet_code){
        state.errors.push("試験IDを入力してください。");
      }

      if(!Common.isApprovalExamSheetType(state.baseSheet.sheet_type)){
        state.errors.push("試験種別を選択してください。");
      }

      if(!state.baseSheet.nendo){
        state.errors.push("年度を入力してください。");
      }else if(!new RegExp(/^[0-9]+$/).test(state.baseSheet.nendo)){
        state.errors.push("年度は半角整数で入力してください。");
      }else if(`${Number(state.baseSheet.nendo)}`.length != 4){
        state.errors.push("年度は西暦4桁で入力してください。");
      }

      if(!state.baseSheet.subject_code){
        state.errors.push("科目を入力してください。");
      }

      if(!state.baseSheet.report_no){
        state.errors.push("回次を入力してください。");
      }else if(!new RegExp(/^[0-9]+$/).test(state.baseSheet.report_no)){
        state.errors.push("回次は半角整数で入力してください。");
      }else if(Number(state.baseSheet.report_no) < 1 || Number(state.baseSheet.report_no) > 50){
        state.errors.push("回次は1～50で入力してください。");
      }

      if(!state.baseSheet.name){
        state.errors.push("試験名を入力してください。");
      }

      if(!Common.isInteger(state.baseSheet.passing_score)){
        state.errors.push("合格点を入力してください。");
      }

      if(!state.baseSheet.qr_code){
        state.errors.push("QRコードを入力してください。");
      }

      if(state.errors.length > 0){
        window.scroll({top: 0, behavior: 'smooth'});
        return;
      }

      if(state.baseSheet.requiresFollowUpSetting){
        // 得点枠の再設定が必要な場合に注意を促す確認メッセージを表示
        customConfirmModalRef.value.show();
      }else if(window.confirm("試験情報を更新します。よろしいですか？")){
        await update();
      }
    };

    const update = async () => {

      customConfirmModalRef.value.hide();

      context.root.$store.dispatch("showOverlay");
      
      await http.post(`/api/teacher/approval_base_sheet_edit/update/${state.base_sheet_id}`, {base_sheet: state.baseSheet}).then(response => {
        alert("処理が完了しました。");
        window.history.back();
      })
      .catch(async error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
        window.scroll({top: 0, behavior: 'smooth'});
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      state.base_sheet_id = context.root.$route.params.base_sheet_id;
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/teacher/approval_base_sheet_edit?base_sheet_id=${state.base_sheet_id}`).then(response => {
        state.baseSheet = new BaseSheet(response.data.base_sheet);
        state.isSheetTypeEditable = response.data.is_sheet_type_editable;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
      customConfirmModalRef,
      updateClick,
      update,
      SheetTypeEnum: Common.SheetTypeEnum,
    }
  },
})
